import {
  apiClient,
  type MonthlyCustomerReportListExEntity,
  type PageEntity
} from '@/libs/api'
import { type MonthlyCustomerReportsRequestQuery } from '@/libs/api/types'

export type FetchMonthlyCustomerReportsQuery = {
  tenantKey: string
  query: MonthlyCustomerReportsRequestQuery
}

export type FetchMonthlyCustomerReportsResponse = {
  data: MonthlyCustomerReportListExEntity[]
  pagination: PageEntity | null
}

export const fetchMonthlyCustomerReports = async (
  { tenantKey, query }: FetchMonthlyCustomerReportsQuery,
  signal?: AbortSignal
): Promise<FetchMonthlyCustomerReportsResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .monthly_customer_reports.$get({ query, config: { signal } })
  return { data, pagination }
}
